export default __webpack_public_path__ + "static/media/logo_sayme_header.81fae992.png";